import { render, staticRenderFns } from "./registration.vue?vue&type=template&id=71b1a615"
import script from "./registration.vue?vue&type=script&lang=ts"
export * from "./registration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports